// extracted by mini-css-extract-plugin
export default {"fixedHeader":"Table_fixedHeader__El5mW","table":"Table_table__L+Klp","tdHidden":"Table_tdHidden__KOZF6"};